import {Component} from '@angular/core';
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {ICellRendererAngularComp} from "ag-grid-angular";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {MatDialog} from "@angular/material/dialog";
import {ICellRendererParams} from "ag-grid-community";
import {IFrequentlyAskedQuestions} from "../../../interfaces/IFrequentlyAskedQuestions";
import {FaqsEditComponent} from "../faqs-edit/faqs-edit.component";
import {PermissionsService} from "../../../services/permissions.service";
import {FaqScopeTypes} from "../../../enum/FaqScopeTypes";

@Component({
  selector: 'app-faq-table-settings',
  standalone: true,
  imports: [
    HasPermissionDirective,
    MatIcon,
    MatIconButton,
    MatTooltip
  ],
  templateUrl: './faq-table-setting-components.component.html',
  styleUrl: './faq-table-setting-components.component.css'
})
export class FaqTableSettingComponents implements ICellRendererAngularComp {
  public permissionTypes = PermissionTypes;
  public rowData!: IFrequentlyAskedQuestions;
  public params!: any;
  public canEdit: boolean = false;

  constructor(private matDialog: MatDialog, private permissionsService: PermissionsService) {
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.rowData = params.data;

    // Check if user has permission to edit this specific FAQ type
    if (this.rowData.ScopeType === FaqScopeTypes.WebApp) {
      this.canEdit = this.permissionsService.userHasPermission(PermissionTypes.ModifyWebappFrequentlyAskedQuestions);
    } else if (this.rowData.ScopeType === FaqScopeTypes.AdminApp) {
      this.canEdit = this.permissionsService.userHasPermission(PermissionTypes.ModifyAdminAppFrequentlyAskedQuestions);
    }
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }

  onEditFaqClick() {
    this.matDialog.open(FaqsEditComponent, {
      data: this.rowData,
      width: '650px'
    });
  }
}
